import Rule from "../../../../../common/rule";
import FootballState from "../../../../state/football-state";

/**
 * Rule for when a ball hits the rebound net and then the ground (Indoor Football).
 * The ball is dead at that spot.
 */
export default class ReboundNetHitGround extends Rule {
    // eslint-disable-next-line no-unused-vars
    applicable(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        return fragment.associatedState === FootballState.ReboundNetHitGround;
    }

    // eslint-disable-next-line no-unused-vars
    async apply(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        const { deadAt } = fragment;

        // Ball is dead at the spot
        if (deadAt || deadAt === 0) {
            gameContext.setFieldPosition(deadAt);
        }
    }
}
